import { Button } from "@bowfast/ui/components/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@bowfast/ui/components/empty";
import { AlertCircleIcon, RefreshCwIcon } from "lucide-react";

interface ListLoadErrorProps {
  title: string;
  description?: string;
  onRetry: () => void;
}

export function ListLoadError({
  title,
  description = "Check your connection and try again.",
  onRetry,
}: ListLoadErrorProps) {
  return (
    <Empty className="min-h-[28rem] border border-dashed">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <AlertCircleIcon className="text-signal-500" />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button size="sm" variant="outline" className="gap-2" onClick={onRetry}>
          <RefreshCwIcon className="size-3.5" />
          Try again
        </Button>
      </EmptyContent>
    </Empty>
  );
}
